import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import {
	CSSProperties,
	PropsWithChildren,
	ReactElement
} from "react";
import styles from "./ActionListItem.module.less";
import { useIndention } from "./ActionListItem";

export type ActionListCustomProps = {
	trackingId?: string;
	indentionLevel?: number;
};

export const ActionListCustom = (props: PropsWithChildren<ActionListCustomProps>): ReactElement => {
	const {
		trackingId,
		children,
		indentionLevel
	} = props;

	const style: CSSProperties = useIndention(indentionLevel);

	return (
		<li
			{...setTrackingId(trackingId)}
			className={styles.root}
			style={style}
		>
			<div
				className={classNames(
					styles.contentHost,
					styles.contentHost_custom
				)}
			>
				{children}
			</div>
		</li>
	);
};
ActionListCustom.displayName = "ActionListCustom";
